<div data-test-id="browser-redirect-container"  class="spinner-container">
  <mat-spinner data-test-id="browser-redirect-spinner"  diameter="60" color="primary"></mat-spinner>
</div>
